import { getAllGames } from './Actions/getAllGames';
import { setScorer } from './Actions/setScorer';
import { swapPlayersSeats } from './Actions/swapPlayersSeats';
import { updateGame } from './Actions/updateGame';
import { updateGamePlayerStatus } from './Actions/updateGamePlayerStatus';
import { getAllFutureGames } from './Actions/getAllFutureGames';
import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';
import { getAllFutureClubGames } from './Actions/getAllFutureClubGames';

const actions = {
  getAllFutureClubGames,
  getAllFutureGames,
  getAllGames,
  setScorer,
  swapPlayersSeats,
  updateGame,
  updateGamePlayerStatus
};

export type IGamesActions = TActionsWithoutState<typeof actions>;

export default actions;
